<template>
  <div name="new-contract-note" class="card-padding">
    <div class="card__header">
      <span class="card__header--topic">Contract Notes</span>
    </div>
    <div name="note-container" class="row mt-1">
      <div class="col-12 col-lg-8">
        <atom-text-area v-model="newContractNote" title="Note"></atom-text-area>
      </div>
    </div>
  </div>
</template>

<script>
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
export default {
  name: "MoleculeNewContractNote",
  components: {
    AtomTextArea,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    newContractNote: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.card-padding {
  padding: 21px;
}

.card__header {
  margin-bottom: 14px;
}

.card__header--topic {
  font-weight: 500;
  font-size: 18px;
}
</style>
